import {ApolloClient, InMemoryCache, createHttpLink, ApolloLink} from '@apollo/client/core';
import {onError} from "@apollo/client/link/error";
import {setContext} from "@apollo/client/link/context";
import useNotyf from "/@src/composable/useNotyf";

const notif = useNotyf()

const responseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    // 服务器返回数据
    return response.data
  })
})
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
    if(networkError.message){
      notif.error(networkError.message)
    }else {
      notif.error('Unknown server error')
    }
  }
})

const authOldLink = setContext( () => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      'X-Hufu-Token': token,
    }
  }
});
const authLink = setContext( () => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      'x-token': token,
    }
  }
});
// First Apollo Client
const httpLink1 = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_BASE_URL as string,
});

const client = new ApolloClient({
  link: ApolloLink.from([
    authLink,
    responseLink,
    errorLink,
    httpLink1
  ]),
  cache: new InMemoryCache({
    typePolicies: {
      TagRelation: {
        keyFields: ['id', 'group'],
      },
      Content: {
        keyFields: ['raw_id'],
      },
      Query: {
        fields: {
          contents: {
            keyArgs: [
              'relations',
              'track',
              'sortBy',
              'startTime',
              'endTime',
              'first',
              'kinds',
              'vipVisibility',
            ],
          },
        },
      },
    },
  }),
  defaultOptions:{
    watchQuery: {
      fetchPolicy: 'no-cache',
      nextFetchPolicy: 'no-cache', 
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    mutate:{
      fetchPolicy:'no-cache',
    }
  }
});

// Second Apollo Client
const httpLink2 = createHttpLink({
  uri: import.meta.env.VITE_API_BASE_URL as string + '/graphql/',
});

const clientOld = new ApolloClient({
  link: ApolloLink.from([
    authOldLink,
    errorLink,
    httpLink2
  ]),
  cache: new InMemoryCache(),
  defaultOptions:{
    query:{
      fetchPolicy:'no-cache',
      errorPolicy: 'all'
    }
  }
});

export { client, clientOld };
